















































import { defineComponent } from "@vue/composition-api";
import { useActions } from "vuex-composition-helpers";
import LinkNotificationModel from "@/ts/models/linkNotificationClass";
import NotificationModel from "@/ts/models/notificationClass";

export default defineComponent({
  name: "Notification",

  components: {},

  props: {
    notification: (Object as () => NotificationModel) || LinkNotificationModel
  },

  setup(props) {
    const { SEND_NOTIFICATION_DELETION } = useActions({
      SEND_NOTIFICATION_DELETION: "notification/SEND_NOTIFICATION_DELETION"
    } as any);
    const { SEND_NOTIFICATION_READ } = useActions({
      SEND_NOTIFICATION_READ: "notification/SEND_NOTIFICATION_READ"
    } as any);

    const read = () => {
      if (!props.notification!.read) {
        SEND_NOTIFICATION_READ(props.notification!.id);
      }
    };

    const deleteNotification = () => {
      SEND_NOTIFICATION_DELETION(props.notification!.id);
    };

    return {
      deleteNotification,
      read
    };
  }
});
